/**
 * See the web core module for the original version of this:
 * https://github.com/Root-App/root-monorepo/blob/main/web/modules/core/src/services/analytics-service.js
 */
import environment from '@/environment';
import mixpanel from 'mixpanel-browser';
import sessionId from './session-service';

export const EventTypes = {
  CLICK: 'Click',
  PAGE_VIEW: 'Page View',
};

export type EventProperties = Record<string, string | null>;
export const defaultEventPrefix = 'AGENCY_API_CLIENT';

function initMixpanel(identity?: string | null) {
  mixpanel.init(environment.mixpanelToken);
  if (identity) {
    mixpanel.identify(identity);
  }
}

function track(
  contexts: string[],
  { eventPrefix = defaultEventPrefix, ...properties }: EventProperties = {},
  quoteId: string | null
) {
  const eventName = [eventPrefix]
    .concat(...contexts)
    .filter((n) => n)
    .join('_')
    .toUpperCase();

  if (environment.analyticsLoggingEnabled) {
    console.log('Tracking event:', eventName, properties);
  }

  if (environment.mixpanelEnabled) {
    initMixpanel(quoteId ?? sessionId());

    mixpanel.track(eventName, properties);
  }
}

export function trackEvent(context: string, event: string, properties: EventProperties = {}, quoteId: string | null) {
  track([context, event], properties, quoteId);
}

export function trackViewEvent(context: string, properties: EventProperties = {}, quoteId: string | null) {
  track([context, 'VIEWED'], properties, quoteId);
}

export function trackClickEvent(
  context: string,
  clickContext: string,
  properties: EventProperties = {},
  quoteId: string | null
) {
  track([context, clickContext, 'CLICKED'], properties, quoteId);
}
